import React from "react";

export function MetaInformation({
  title = "My Page",
  ogTitle = "My OG Title",
  ogDescription = "My description",
  chononicalUrl = "https://www.example.com",
}) {
  return (
    <>
      {/* <title>{title}</title>
      <meta property="og:type" content="website" />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:url" content={chononicalUrl} />
      <meta property="og:site_name" content="Sale SpeedUp" />
      <meta property="og:description" content={ogDescription} />
      <link rel="canonical" href={chononicalUrl} />
      <meta
        property="og:image"
        content="https://salespeed.netlify.app/light_mode_transparent_logo.png"
      /> */}
    </>
  );
}
